/* eslint-disable */

function loadFreshWorks(widgetId) {

    window.fwSettings = {

        widget_id: widgetId,

    };

    if (typeof window.FreshworksWidget != 'function') {

        const n = function() {

            n.q.push(arguments);

        };

        n.q = [];
        window.FreshworksWidget = n;

    }

    const fw = document.createElement('script');
    fw.type = 'text/javascript';
    fw.async = true;
    fw.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(fw, s);

}

export default loadFreshWorks;
